import React from 'react';
import { FileText } from 'lucide-react';
import ReactMarkdown from 'react-markdown';

interface CasoChatMessageProps {
  role: 'user' | 'assistant';
  content: string;
  timestamp?: Date;
  sources?: Array<{ label: string; url: string }>;
  isStreaming?: boolean;
}

export const CasoChatMessage: React.FC<CasoChatMessageProps> = ({
  role,
  content,
  timestamp,
  sources,
  isStreaming = false
}) => {
  const isUser = role === 'user';
  
  return (
    <div className={`caso-chat-message ${isUser ? 'caso-chat-message-user' : 'caso-chat-message-assistant'}`}>
      <div className="caso-chat-message-content">
        {isUser ? (
          <p className="whitespace-pre-wrap text-sm leading-relaxed">{content}</p>
        ) : (
          <div className="prose prose-sm dark:prose-invert max-w-none">
            <ReactMarkdown>{content}</ReactMarkdown>
            {isStreaming && content && (
              <span className="inline-block w-2 h-4 bg-current animate-pulse ml-1" />
            )}
          </div>
        )}
      </div>
      
      {!isUser && sources && sources.length > 0 && (
        <div className="caso-chat-sources">
          <FileText className="caso-chat-sources-icon" />
          <span className="caso-chat-sources-label">Fontes consultadas:</span>
          <div className="caso-chat-sources-list">
            {sources.map((s, i) => (
              <span key={i} className="caso-chat-source-badge" title={s.url}>
                {s.label}
              </span>
            ))}
          </div>
        </div>
      )}
      
      {timestamp && (
        <div className="caso-chat-message-time">
          {timestamp.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}
        </div>
      )}
    </div>
  );
};
